import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./template_hidden_special_offer.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
